import React from 'react';
import Link from 'gatsby-link';
import styles from "../css/services.css";
import animate from "../../static/lib/animate/animate.min.css";

const Services = () => (
    <div id="services-page">
        <section className="pageHeader" id="services-header">
            <div className="container py-5">
                <h1>Services</h1>
            </div>
        </section>
        <section className="container small-container text-center bounceInDown animated" id="service-types">
            <div className="row" id="service-list">
                <div className="col-12 text-orange text-center mb-4">
                    <h2>
                        Services &amp; Solutions For You
                    </h2>
                </div>

                <a href="#ios-android-dev" className="card col-6 col-sm-4 col-md-3 services-icon-outer">
                    <div className="services-icon-inner">
                        <img src="../../images/services/android-ios.png" className="img-fluid orange-icon" />
                        <img src="../../images/services/android-ios-white.png" className="img-fluid white-icon" />
                        <h3>
                            iOS / Android
                            <br />
                            Development
                        </h3>
                    </div>
                </a>

                <a href="#desktop-app-section" className="card col-6 col-sm-4 col-md-3 services-icon-outer">
                    <div className="services-icon-inner">
                        <img src="../../images/services/windows-icon.png" className="img-fluid orange-icon" />
                        <img src="../../images/services/windows-icon-white.png" className="img-fluid white-icon" />
                        <h3>
                            Desktop App
                        <br />
                            Development
                    </h3>
                    </div>
                </a>

                <a href="#web-section" className="card col-6 col-sm-4 col-md-3 services-icon-outer">
                    <div className="services-icon-inner">
                        <img src="../../images/services/computer-web.png" className="img-fluid orange-icon" />
                        <img src="../../images/services/computer-web-white.png" className="img-fluid white-icon" />
                        <h3>
                            Web Development
                        </h3>
                    </div>
                </a>

                <a href="#technical-section" className="card col-6 col-sm-4 col-md-3 services-icon-outer">
                    <div className="services-icon-inner">
                        <img src="../../images/services/consultant.png" className="img-fluid orange-icon" />
                        <img src="../../images/services/consultant-white.png" className="img-fluid white-icon" />
                        <h3>
                            Technical Consulting
                        </h3>
                    </div>
                </a>
            </div>
        </section>



        {/* content section */}
        <section className="container" id="ios-android-section">
            <div className="row">
                <div className="col-12 col-md-6">
                    <h2 id="ios-android-dev" className="text-orange">
                        iOS / Android Development
                    </h2>
                    <p>
                        A portfolio of products released on the App Store &amp; Google Play Store. 
                        We aim for all mobile software applications to be cross platform with little
                        variation between the platforms.
                    </p>
                </div>
            </div>
        </section>


        <section className="container" id="desktop-app-section">
            <div className="row">
                <div className="col-12 col-md-6">
                </div>
                <div className="col-12 col-md-6 text-right">
                    <h2 id="desktop-app-dev" className="text-orange ">
                        Desktop App Development
                    </h2>
                    <p>
                        With experience developing large and small bespoke software packages, 
                        the KentWeb team is can offer a trustworthy and reputable service for developing 
                        your bespoke application.
                    </p>
                </div>
            </div>
        </section>


        <section className="container" id="web-section">
            <div className="row">
                <div className="col-12 col-md-6">
                    <h2 id="web-dev" className="text-orange">
                        Website Development
                    </h2>
                    <p>
                        We Design &amp; develop custom web applications, fitting to your specific business requirements.
                    </p>
                    <p>
                        Our portfolio includes large scale E-commerce websites &amp; creative marketing websites to complex
                        custom web applications.
                    </p>
                </div>
            </div>
        </section>


        <section className="container" id="technical-section">
            <div className="row">
                <div className="col-12 col-md-6">
                </div>
                <div className="col-12 col-md-6 text-right">
                    <h2 id="technical-dev" className="text-orange ">
                        Technical Consulting
                    </h2>
                    <p>
                        KentWeb offers expert advice for small businesses looking to automate their workflow and move into the cloud.
                    </p>
                    <p>
                        Adopt new solutions meeting GDPR requirements.
                    </p>
                </div>
            </div>
        </section>
    </div>

);

export default Services;



// WEBPACK FOOTER //
// ./src/pages/services.js